module.exports = __webpack_public_path__ + "static/media/wm-gigafactory-cropped.4a044c40.jpg";